import { Sort } from "@models";
import { randomNumber } from "./number";

export const defaultSort = (direction: Sort) => (a: any, b: any) => {
    // force null and undefined to the bottom
    const directionCoefficient = direction === Sort.Asc ? 1 : -1;
    a = a ?? directionCoefficient * Infinity;
    b = b ?? directionCoefficient * Infinity;
    // force any string values to lowercase
    a = typeof (a) === 'string' ? a.toLowerCase() : a;
    b = typeof (b) === 'string' ? b.toLowerCase() : b;
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
        return directionCoefficient;
    }
    if (a < b) {
        return -directionCoefficient;
    }
    return 0;
};

export function mapByKey<T, K extends keyof T>(items: T[], key: K): T[K][] {
    return items.map(item => item[key]) as T[K][];
}

export function excludeNullable<T>(items: (T | null | undefined)[]): T[] {
    return items.filter(item => item !== null && item !== undefined) as T[];
}

export function bubbleUp<T>(items: T[], key: keyof T, value: T[keyof T]): T[] {
    return [
        ...items.filter(item => item[key] === value),
        ...items.filter(item => item[key] !== value),
    ];
}

export function randomizeItems<T>(items: T[], count?: number): T[] {
    // Generate a random number between 0 and 1 and then deduct half to get positive/negative for random sort
    return items.sort(() => randomNumber() - 0.5).slice(0, count ?? items.length);
}
